import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Get all templates
 */
export async function getProjectTemplates({
    projectId,
    searchQuery = '',
    page = 1,
    limit = 0,
    includeGlobal = 0,
    sortBy = 'name',
    sortOrder = true,
    type = 'private',
}) {
    if (isAuthenticated()) {
        searchQuery = searchQuery.length ? `&search=${searchQuery}` : '';
        let includeGlobalQuery = `includeGlobal=${includeGlobal}`,
            limitQuery = `&limit=${limit}`,
            pageQuery = `&page=${page}`,
            sortByQuery = `&sortBy=${sortBy}`,
            sortOrderQuery = `&sortOrder=${sortOrder ? 'desc' : 'asc'}`,
            sortQuery = sortByQuery + sortOrderQuery,
            pageType = `&type=${type}`,
            buildQuery =
                includeGlobalQuery +
                limitQuery +
                pageQuery +
                searchQuery +
                sortQuery +
                pageType;

        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/templates?projectId=${projectId}&${buildQuery}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );
        return await response.json();
    }
}

/**
 * Assign a template
 */

export async function assignTemplateToLivepage(
    projectId,
    showcaseId,
    templateId
) {
    if (isAuthenticated()) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/projects/${projectId}/showcase/${showcaseId}/assign/${templateId}?includeGlobal=0`,
            {
                method: 'POST',
                headers: {
                },
            }
        );
        return await response.json();
    }
}

/**
 * Get specific template
 */

export async function getLivePageTemplate(projectId, showcaseId) {
    if (isAuthenticated()) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/projects/${projectId}/showcase/${showcaseId}/template`,
            {
                method: 'GET',
                headers: {
                },
            }
        );
        return await response.json();
    }
}
